import http from "./http-common";
import JWT from "./Jwt"; 

/**
 * @class AlarmaSMSDataService
 * @brief Clase del servicio de alarmas SMS que permite consultar, almacenar, actualizar y eliminar la configuración de los dispositivos.
 */
class AlarmaSMSDataService{
  
    /** 
     * @brief Método que consulta todas las configuraciones.
     * @returns {Promise<AxiosResponse<any>>} Lista de configuraciones.
     */
    getAll() {
        return http.get(localStorage.getItem('servidor')+"/asincrona/configuracion/"); //listado de configuraciones
    }

    /**
     * @brief Metodo que permite agregar una configuración en base de datos.
     * @param data Objeto que contiene la configuración del dispositivo.
     * @returns {Promise<AxiosResponse<any>>} Respuesta de la peticion de creacion.
     */
    create(data){
      return http.post(localStorage.getItem('servidor')+"/asincrona/configuracion/", JWT.jwtEncodeJson(data));
    }

    /**
     * @brief Método que permite actualizar la configuración del dispositivo.
     * @param data Objeto que contiene la configuración actualizada del dispositivo.
     * @returns {Promise<AxiosResponse<any>>} Respuesta de la peticion de actualizacion.
     */
    update(data){
      return http.put(localStorage.getItem('servidor')+"/asincrona/configuracion/"+ JWT.jwtEncode(sessionStorage.idAlarmaSMS), JWT.jwtEncodeJson(data))
    }

    /**
     * @brief Método que permite enviar mensajes al arduino.
     * @param mensaje Contenido del número y mensaje a enviar.
     * @returns {Promise<AxiosResponse<any>>} Respuesta de la peticion de creacion.
     */
    enviar(mensaje){
      return http.get(localStorage.getItem('servidor')+"/asincrona/configuracion/enviar/"+ JWT.jwtEncode(mensaje)); //listado de configuraciones
    }
}
/**
 * @brief Método que permite exportar los métodos de alarmaSMSDataServices.
 * @type {AlarmaSMSDataService}
 */
export default new AlarmaSMSDataService();